import { useQuery } from "@tanstack/react-query"
import { botBuilderKeys, getPublishPreview, type ScenarioDraft } from "@/entities/bot-builder"
import { countDiff } from "../ui/diff-view"

/**
 * Сколько правок черновика ещё не опубликовано. Считает сервер тем же сравнением,
 * что и окно публикации, и только когда черновик сохранился.
 */
export function usePendingChanges(draft: ScenarioDraft | null | undefined, isSaving: boolean) {
	const preview = useQuery({
		queryKey: [...botBuilderKeys.scenario(draft?.id ?? ""), "publish-preview", draft?.revision],
		queryFn: () => getPublishPreview(draft?.id ?? ""),
		enabled: !!draft && !isSaving,
		staleTime: 30_000,
	})
	return preview.data ? countDiff(preview.data.diff) : null
}
